import React from 'react';

import * as styles from './styles/styles.module.scss';

export default function CloudToggleFilter({ config, handler, variant, context }) {
  const eventTrigger = context && context.mobileBrowser ? 'onTouchEnd' : 'onClick';

  const renderOptions = options => {
    const result = Object.entries(options).map(([key, option]) => {
      const eventHandler = { [eventTrigger]: handler(key) };

      return (
        <div {...eventHandler} key={key} className={`${option.selected ? styles.active : ''} ${styles.button}`}>
          {option.name}
        </div>
      );
    });
    return result;
  };

  return (
    <div>
      <div className={`${styles.list} ${styles[variant]}`}>{renderOptions(config)}</div>
    </div>
  );
}
